.group {
  display: inline-flex;
  border: 1px solid var(--edge);
  border-radius: var(--radius);
  overflow: hidden;
  background: var(--surface-panel);
}

.option {
  padding: 0.3rem 0.6rem;
  font-family: var(--font-chrome);
  font-size: 0.625rem;
  letter-spacing: var(--track-tight);
  text-transform: uppercase;
  color: var(--ink-faint);
  background: transparent;
  border: 0;
  cursor: pointer;
  transition: color 160ms var(--ease-out), background 160ms var(--ease-out);
}

.option + .option {
  border-left: 1px solid var(--edge);
}

.option:hover {
  color: var(--ink);
}

.option[aria-pressed='true'] {
  color: var(--surface-void);
  background: var(--ink);
}
